/* NO FAITH STUDIOS — Product card gallery
   Desktop: arrows to cycle + swap to 2nd image on hover.
   Mobile: a tap opens the product. Hold a finger on the card and it swaps to
   the 2nd image; lift and it goes back. No swiping. */
(function () {
  if (window.__nfsCardInit) return;
  window.__nfsCardInit = true;

  function imgs(card) {
    return Array.prototype.slice.call(card.querySelectorAll('.nfs-card__img'));
  }
  function activeIndex(list) {
    for (var i = 0; i < list.length; i++) if (list[i].classList.contains('is-active')) return i;
    return 0;
  }
  function setActive(card, index) {
    var list = imgs(card);
    if (!list.length) return;
    var next = (index + list.length) % list.length;
    list.forEach(function (el, i) { el.classList.toggle('is-active', i === next); });
  }
  // An arrow or a swipe is the shopper deliberately choosing an image, unlike a
  // hover or a hold, which are previews that snap back. The PLP's View menu also
  // owns the resting image of every card and re-applies it on mouseleave and
  // touchend — which landed right on top of a swipe and pulled the photo back
  // before you let go. This flag tells it to leave the card alone.
  function pick(card) { card.dataset.nfsPicked = '1'; }
  // The image a card rests on. Detail view leaves it at 0, Full body view sets
  // it to 1 through data-nfs-base (see the View menu in the collection
  // section), and a card can sit on any index once an arrow has been used.
  // Everything below works relative to THIS, not to a hard-coded 0 — which is
  // why hover did nothing in Full body view: the card was already showing image
  // 1, so the old `if (activeIndex === 0)` test never passed.
  function baseIndex(card) { return parseInt(card.getAttribute('data-nfs-base'), 10) || 0; }

  // A phone fires a SYNTHETIC mouseover after every tap. It used to reach the
  // hover handler below, which put the card back on image 2 — and since no
  // pointer ever leaves a touchscreen, no mouseout followed and the card stayed
  // there for good. That is the "hover not working properly": one tap and the
  // photo never came back.
  //
  // Two guards, because one is not enough. The media query rules out phones
  // outright. The timestamp covers a touchscreen laptop, which honestly answers
  // "yes" to both hover and fine pointer and would still emit the synthetic
  // event after a finger tap; real mouse movement more than half a second after
  // the last touch is taken at face value.
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var lastTouch = 0;
  function mouseIsReal() {
    if (!canHover.matches) return false;
    return (Date.now() - lastTouch) > 500;
  }

  // Arrows
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nfs-arrow]');
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('[data-nfs-card]');
    if (!card) return;
    var list = imgs(card);
    var dir = btn.getAttribute('data-nfs-arrow') === 'next' ? 1 : -1;
    setActive(card, activeIndex(list) + dir);
    pick(card);
  });

  // Desktop hover: show the image AFTER the one the card rests on
  document.addEventListener('mouseover', function (e) {
    if (!mouseIsReal()) return;
    var card = e.target.closest('[data-nfs-card]');
    if (!card || card.__nfsHover) return;
    var list = imgs(card);
    if (list.length < 2) return;
    card.__nfsHover = true;
    var base = baseIndex(card);
    if (activeIndex(list) === base) setActive(card, base + 1);
  });
  document.addEventListener('mouseout', function (e) {
    if (!mouseIsReal()) return;
    var card = e.target.closest('[data-nfs-card]');
    if (!card) return;
    if (e.relatedTarget && card.contains(e.relatedTarget)) return;
    card.__nfsHover = false;
    // An arrow click is a deliberate choice and outlives the pointer leaving.
    if (card.dataset.nfsPicked) return;
    setActive(card, baseIndex(card));
  });

  // ----- Touch: hold to see the 2nd photo, tap to open the product -----
  //
  // Three things have to be true at once, and each one was broken:
  //
  //   A tap must open the product. So the swap cannot fire on touchstart, and
  //   it has to wait long enough to tell a tap from a press.
  //
  //   A drag must scroll the page and nothing else. The swap used to happen on
  //   touchstart, so every card the finger crossed flicked to its second photo
  //   and back.
  //
  //   A press must NOT open the product when the finger lifts. A long press
  //   still ends in a click, so holding to look at the second photo dropped
  //   you on the product page anyway and the gesture was unreachable. The
  //   click that follows a press is swallowed below.
  //   The brand's own site does this in thirteen lines, and seeing them settles
  //   what the written notes could not:
  //
  //     item.addEventListener('touchstart', () => item.classList.add('hover'));
  //     item.addEventListener('touchend',   () => item.classList.remove('hover'));
  //
  //   No timer. The second photo appears the instant the finger lands and goes
  //   when it lifts — "show the second picture when your finger is on the
  //   product", exactly as written. And the tap still opens the product,
  //   because nothing swallows the click.
  //
  //   This used to wait 200ms to tell a tap from a press, and swallow the click
  //   after a press. That made the gesture a LONG press and left a quick tap
  //   showing nothing, which is what "hover still not working" kept meaning.
  //
  //   No movement threshold either, deliberately. One was tried, so that a
  //   scroll starting on a card put the photo back instead of holding it, but
  //   touch events stay with the element the finger landed on: only that one
  //   card is affected, and only until the finger lifts. That is a small enough
  //   difference that matching the reference exactly is worth more than
  //   improving on it.

  document.addEventListener('touchstart', function (e) {
    lastTouch = Date.now();
    var card = e.target.closest('[data-nfs-card]');
    if (!card) return;
    if (e.target.closest('[data-nfs-arrow]') || e.target.closest('[data-nfs-quickview]') || e.target.closest('[data-nfs-quickadd]')) return;
    card.__nfsT = { preview: false };
    var list = imgs(card);
    var base = baseIndex(card);
    if (list.length >= 2 && activeIndex(list) === base) {
      card.__nfsT.preview = true;
      setActive(card, base + 1);
    }
  }, { passive: true });

  // Kept only to keep the synthetic-mouse guard fed during a long drag; the
  // photo is left alone, as on the reference site.
  document.addEventListener('touchmove', function () { lastTouch = Date.now(); }, { passive: true });

  function endTouch(e) {
    lastTouch = Date.now();
    var card = e.target.closest('[data-nfs-card]');
    if (!card || !card.__nfsT) return;
    if (card.__nfsT.preview) setActive(card, baseIndex(card));
    // The click is NOT swallowed. On the brand's site a tap shows the second
    // photo while the finger is down and then opens the product, and that is
    // the behaviour being matched. Swallowing it was only ever needed because
    // the gesture used to be a long press.
    card.__nfsT = null;
  }
  document.addEventListener('touchend', endTouch, { passive: true });
  document.addEventListener('touchcancel', endTouch, { passive: true });
})();